export default "__VITE_ASSET__ea779d9a__";